













import { defineComponent } from '@vue/composition-api'
import Layout from './components/Layout.vue'
import { MENU_ITEMS } from './appConfigs'

// @vue/component
export default defineComponent({
  components: {
    Layout
  },

  setup() {
    return {
      menuItems: MENU_ITEMS
    }
  }
})
